import type React from 'react';
import loadingSvg from './assets/loading.svg';
import checkSvg from './assets/check.svg';
import { styled } from '@mui/material/styles';
import { ReactSVG } from 'react-svg';

interface PreviewInfoProps {
  intentTitle?: string;
  isModelTraining?: boolean;
}

const ModelTrainingIndicator: React.FC<
  React.PropsWithChildren<PreviewInfoProps>
> = ({ intentTitle, isModelTraining }) => {
  return (
    <Wrapper>
      <IndicatorFrame />
      <Intent>
        {!!intentTitle ? `Intent: ${intentTitle}` : 'All active intents'}
      </Intent>
      <ModelTraining isModelTraining={isModelTraining}>
        {isModelTraining ? (
          <>
            <SVGContainer isModelTraining={isModelTraining}>
              <ReactSVG src={loadingSvg} />
            </SVGContainer>
            Intent model is training. This may take a few minutes.
          </>
        ) : (
          <>
            <SVGContainer isModelTraining={isModelTraining}>
              <ReactSVG src={checkSvg} />
            </SVGContainer>
            Model training is complete.
          </>
        )}
      </ModelTraining>
    </Wrapper>
  );
};

const Intent = styled('p')`
  margin: 0 auto;
  font-size: 12px;
  line-height: 18px;
  color: ${props => props.theme.palette.colors.grey[600]};
  padding: 0 8px;
  background-color: ${props => props.theme.palette.colors.white};
  width: 165px;
  position: relative;
`;

const ModelTraining = styled('div')<{ isModelTraining?: boolean }>`
  margin: 0 auto;
  font-size: 12px;
  line-height: 18px;
  color: ${props => props.theme.palette.colors.grey[600]};
  padding: 0 8px;
  background-color: ${props => props.theme.palette.colors.white};
  position: relative;
  box-sizing: border-box;
  width: 100%;
`;

const SVGContainer = styled('div')<{ isModelTraining?: boolean }>`
  margin-right: 6px;
  vertical-align: ${props => (!!props.isModelTraining ? '-3px' : 'inherit')};
  display: inline-block;

  & div {
    display: inline-block;
  }
`;

const IndicatorFrame = styled('div')`
  position: absolute;
  height: 1px;
  background: ${props => props.theme.palette.colors.slate[200]};
  width: 100%;
  transform: translateY(8px);
`;

const Wrapper = styled('div')`
  background-color: ${props => props.theme.palette.colors.white};
  position: fixed;
  width: calc(100% - 48px);
  text-align: center;
  left: 24px;
  top: 104px;
  transform: translateY(-16px);
  padding-top: 12px;
  z-index: 3;
`;

export default ModelTrainingIndicator;
